const state = {
  navObj: null,
  navObjChildren: null,
  userInfo: ''
}

const actions = {
  // 点击Nav时操作
  setNav({commit}, navObj) {
    commit('SET_NAV', navObj)
  },
  // 点击Nav增加children
  setNavChildren({commit}, navObj) {
    commit('SET_NAV_CHILDREN', navObj)
  },
  // 设置useInfo
  setUserInfo({commit}, val) {
    commit('SET_USER_INFO', val)
  }
}

const mutations = {
  SET_NAV(state, navObj) {
    state.navObj = navObj;
  },
  SET_NAV_CHILDREN(state, navObj) {
    state.navObjChildren = navObj
  },
  SET_USER_INFO(state, val) {
    state.userInfo = val;
  }
}

export default {
  namespaced: true,
  state,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/vuex/modules/header.js